/*
  sl-jump — in-page jump links, and a way back from them.

  Any anchor marked [data-sl-jump] scrolls smoothly to the section it points at and leaves
  behind a floating "Back" pill. Tapping that pill returns the reader to the exact spot they
  jumped from — not the top of the page, which is what a bare back-to-top button gives you
  and is almost never where they were.

  Why a pill and not browser history: the jump is a scroll, not a navigation, so Back in the
  browser leaves the page entirely. The pill is the only affordance that undoes the jump.

  The aiming routine mirrors sections/sl-hero.liquid: lazy media above the target keeps
  growing the page mid-flight, so one measurement lands short, and a correction issued
  mid-flight would stop the page dead and set off again. Aim once, wait for genuine
  stillness, correct at most twice.
*/
(function () {
  if (window.__slJump) return;
  window.__slJump = true;

  var OFFSET = 80;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var origin = null;
  var travelled = false;
  var pill = null;

  function scrollTo(y) {
    window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
  }

  function whenStill(done) {
    var last = -1, stable = 0;
    var timer = setInterval(function () {
      var y = window.pageYOffset;
      if (y === last) stable++; else { stable = 0; last = y; }
      if (stable >= 2) { clearInterval(timer); done(); }
    }, 50);
    setTimeout(function () { clearInterval(timer); }, 6000);
  }

  function travel(target) {
    var corrections = 0, abandoned = false;

    // Once the reader takes the wheel, the trip is theirs.
    function abandon() { abandoned = true; }
    ['wheel', 'touchstart', 'keydown'].forEach(function (evt) {
      window.addEventListener(evt, abandon, { passive: true, once: true });
    });

    function aim() {
      scrollTo(target.getBoundingClientRect().top + window.pageYOffset - OFFSET);
    }

    function settle() {
      if (abandoned) return;
      if (Math.abs(target.getBoundingClientRect().top - OFFSET) <= 24) return;
      if (++corrections > 2) return;
      aim();
      whenStill(settle);
    }

    aim();
    whenStill(settle);
  }

  function buildPill() {
    var el = document.createElement('button');
    el.type = 'button';
    el.className = 'sl-jump-back';
    el.setAttribute('hidden', '');
    el.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
      '<path d="M12 19V5"/><path d="M5 12l7-7 7 7"/></svg><span></span>';
    el.addEventListener('click', function () {
      if (origin === null) return;
      var y = origin;
      hide();
      scrollTo(y);
    });
    document.body.appendChild(el);
    return el;
  }

  function show(label) {
    if (!pill) pill = buildPill();
    pill.querySelector('span').textContent = label;
    pill.removeAttribute('hidden');
    // One frame later, so the transition has a start state to animate from.
    requestAnimationFrame(function () { pill.classList.add('is-in'); });
  }

  function hide() {
    origin = null;
    travelled = false;
    if (!pill) return;
    pill.classList.remove('is-in');
    var el = pill;
    setTimeout(function () { if (!el.classList.contains('is-in')) el.setAttribute('hidden', ''); }, 220);
  }

  /* Shopify renders a template section as id="shopify-section-template--<theme id>__<key>".
     That theme id changes the moment the theme is duplicated or published, so a page cannot
     store the full id. It stores the section key instead and we match on the suffix. */
  function resolve(id) {
    if (!id) return null;
    return document.getElementById(id) ||
           document.querySelector('[id$="__' + id + '"]') ||
           document.querySelector('[id$="-' + id + '"]');
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-sl-jump]');
    if (!link) return;
    var id = (link.getAttribute('href') || '').replace(/^#/, '');
    var target = resolve(id);
    if (!target) return;

    e.preventDefault();
    origin = window.pageYOffset;
    travelled = false;
    travel(target);
    show(link.getAttribute('data-sl-jump-back') || 'Back');
  });

  /* If the reader walks back up past where they jumped from, the pill has nothing left to
     undo, so it gets out of the way.

     The `travelled` latch matters: the very first scroll event after a jump fires while the
     page is still sitting AT the origin, which would otherwise read as "already back" and
     throw the origin away one frame after storing it — leaving a pill that does nothing. */
  window.addEventListener('scroll', function () {
    if (origin === null) return;
    var y = window.pageYOffset;
    if (!travelled) {
      if (y > origin + 200) travelled = true;
      return;
    }
    if (y <= origin + 40) hide();
  }, { passive: true });
})();
